import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=41f158ce&scoped=true"
import script from "./ViewItem.vue?vue&type=script&lang=js"
export * from "./ViewItem.vue?vue&type=script&lang=js"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=41f158ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f158ce",
  null
  
)

export default component.exports